export const MilestoneActionType = {
  Add: 'Add',
  Delete: 'Delete',
  Update: 'Update',
  Init: 'Init',
};
